import DatePicker from '../base';

const selectors = {
  pickerEl: '[data-comp-input-date-picker]',
  pickerDisplayInput: '[data-input-date-picker-display]'
};

const months = ['Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov'];
const delimitir = ' - ';

const pickerOptions = {
  element: null,
  singleMode: false,
  minDate: new Date().getTime(),
  showTooltip: false,
  firstDay: 0,
  autoApply: false,
  buttonText: {
    "cancel": "Clear",
    "nextMonth": "<svg width='9' height='13' viewBox='0 0 9 13' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1 12L7 6.5873L1 0.999999' stroke='currentColor' stroke-width='2' /></svg>",
    "previousMonth": "<svg width='9' height='13' viewBox='0 0 9 13' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8 1L2 6.4127L8 12' stroke='currentColor' stroke-width='2'/></svg>"
  },
  setup: (picker) => {
    picker.on('selected', () => {
      pickerOptions.element.dispatchEvent(new Event('input'));
      updateDisplayInput();
    });

    picker.on('button:cancel', () => {
      picker.clearSelection();
      pickerOptions.element.dispatchEvent(new Event('input'));
      updateDisplayInput();
    });
  },
};

export default class InputDatePicker extends DatePicker {
  static loaderPriority = 'in-view';
  static selector = selectors.pickerEl;
  constructor(containerEl) {
    super(containerEl);
    const eventDates = this.$container.dataset.eventDates
    if (eventDates) {
      pickerOptions.highlightedDays = JSON.parse(eventDates);
    }

    pickerOptions.element = containerEl;
    this.inputDatePicker = new this.DatePicker(pickerOptions);
    this.addInitialInputDisplayValue();
    this.events();
  }

  addInitialInputDisplayValue() {
    if (this.$container.value) {
      updateDisplayInput();
    }
  }

  events() {
    window.addEventListener('resetDatePicker', () => {
      this.inputDatePicker.clearSelection();
      updateDisplayInput();
    });
  }
}

function updateDisplayInput() {
  const datePickerValue = pickerOptions.element.value;
  const datePickerDisplay = pickerOptions.element.parentElement.querySelector(selectors.pickerDisplayInput);

  if (datePickerValue === '') {
    datePickerDisplay.value = '';
    return;
  }

  const selectedDates = datePickerValue.split(delimitir);
  const startDate = selectedDates[0];
  const endDate = selectedDates[1];

  if (startDate === endDate) {
    const formattedDate = formatDate(startDate);
    datePickerDisplay.value = formattedDate;
  } else {
    const formattedDate = `${formatDate(startDate)}${delimitir}${formatDate(endDate)}`;
    datePickerDisplay.value = formattedDate;
  }
}

function formatDate(givenDate) {
  const dateArr = givenDate.split('-');
  const givenYear = dateArr[0];
  const givenMonth = dateArr[1];
  const givenDay = dateArr[2];
  const newDate = new Date(givenYear, givenMonth, givenDay);

  const newMonth = months[newDate.getMonth()];
  const newDay = newDate.getDate();

  return `${newMonth} ${newDay}`;
}
